import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import TheDrawer from '@/components/TheDrawer.vue';
import TheHeader from '@/components/TheHeader.vue';
import TheProgramDrawer from '@/components/TheProgramDrawer.vue';
import TheInfoDrawer from '@/components/TheInfoDrawer.vue';
import { useProgramsStore } from '@/stores/programs';
import { useTrackersStore } from '@/stores/trackers';
import { onMounted } from 'vue';
import TheTrackerDrawer from '@/components/TheTrackerDrawer.vue';
import TheTooltip from '@/components/TheTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const programsStore = useProgramsStore()
const trackersStore = useTrackersStore()

onMounted(() => {
  programsStore.init()
  trackersStore.init()
})


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheDrawer),
    _createVNode(TheHeader),
    (_unref(programsStore).status === 'loaded')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(TheInfoDrawer),
          _createVNode(TheProgramDrawer),
          _createVNode(TheTrackerDrawer)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(TheTooltip),
    _createVNode(_component_v_main, null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })
  ], 64))
}
}

})